<script>
  import { Modal } from 'bootstrap';
  import { getContext, onMount } from 'svelte';
  import Loader from '../components/Loader.svelte';
  export let handleClick = (e) => {};
  let reason = '';
  let isLoading = false;
  export let requestFrom = '';
  let openDueDateModal;
  onMount(() => {
    openDueDateModal = new Modal(document.getElementById('openDueDateModal'), {
      keyboard: false,
    });
  });
  import * as yup from 'yup';
  export let success = () => {};
  export const show = (data) => {
    serverErrors = [];
    isLoading = false;
    $form = data;
    openDueDateModal.show();
  };
  export const showModal = () => {
    reason = '';
    openDueDateModal.show();
  };
  const showDialog = getContext('showDialog');
  let defaultValue = {
    comeFrom: '',
    dateType: '',
    date: '',
    date2: '',
    reason: '',
    tasks: [],
  };
  import DatePicker from './Flatpickr/DatePicker.svelte';
  import { createForm } from 'svelte-forms-lib';
  import { client } from 'root/api/index.js';
  import InfoAlert from './Alert/InfoAlert.svelte';
  let serverErrors = [];
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      dateType: yup.string().required('Please select type'),
      date: yup.string().required('Date is required'),
      date2: yup.string().when('dateType', {
        is: 'both',
        then: yup.string().required('Date is required'),
      }),
      reason: yup.string(),
    }),
    onSubmit: (values) => {
      serverErrors = [];
      client
        .taskChangeOpenDueDateComplete(values)
        .then(async (result) => {
          openDueDateModal.hide();
          success($form);
        })
        .catch((err) => {
          serverErrors = err.message;
          showDialog({
            message: `${err}`,
            okFunc: () => {
              isLoading = false;
              showModal();
            },
          });
          openDueDateModal.hide();
        });
    },
  });
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="openDueDateModal"
  tabindex="-1"
  aria-labelledby="openDueDateModal"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14"
            id="exampleModalLabel"
          >
            {#if $form.dateType == 'completeDate'}
              Change Completion Date
            {:else if $form.comeFrom == 'bulk'}
              Change Open & Due Date
            {:else if $form.dateType == 'openDate'}
              Change Open Date
            {:else if $form.dateType == 'dueDate'}
              Change Due Date
            {/if}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            {#if $form.dateType != 'completeDate' && $form.comeFrom == 'bulk'}
              <div class="position-relative">
                <div
                  class="btn-group w-100 common-btn-group me-1 button-tabber-modal mb-3"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    on:click={() => ($form.dateType = 'openDate')}
                    class="btn font-size-12 tabber-btn align-items-center d-flex flex-row shadow-none {$form.dateType ==
                    'openDate'
                      ? 'active'
                      : null}"
                  >
                    Open Date
                  </button>
                  <button
                    type="button"
                    on:click={() => ($form.dateType = 'dueDate')}
                    class="btn font-size-12 tabber-btn align-items-center d-flex flex-row shadow-none {$form.dateType ==
                    'dueDate'
                      ? 'active'
                      : null} "
                  >
                    Due Date
                  </button>
                  <button
                    type="button"
                    on:click={() => ($form.dateType = 'both')}
                    class="btn font-size-12 tabber-btn align-items-center d-flex flex-row shadow-none {$form.dateType ==
                    'both'
                      ? 'active'
                      : null} "
                  >
                    Both
                  </button>
                </div>
                {#if $errors.dateType}
                  <label
                    class="formError"
                    style="top: 8px;bottom: auto;"
                    for="reason">{$errors.dateType}</label
                  >
                {/if}
              </div>{/if}
            <div class="row">
              <div class="col-md-6">
                <div class="form-group position-relative">
                  <label
                    for=""
                    class="form-label mt-2"
                    >{$form.dateType == 'dueDate' && $form.dateType != 'both'
                      ? 'Due Date'
                      : $form.dateType == 'completeDate'
                        ? 'Completion Date'
                        : 'Open Date'}</label
                  >
                  <DatePicker
                    style="active select-border"
                    placeholder="Date"
                    on:change={(value) => {
                      $form.date = value.detail[1];
                    }}
                    value={$form.date}
                  />
                  {#if $errors.date}
                    <label
                      class="formError"
                      for="reason">{$errors.date}</label
                    >
                  {/if}
                </div>
              </div>
              {#if $form.dateType == 'both'}
                <div class="col-md-6">
                  <div class="form-group position-relative">
                    <label
                      for=""
                      class="form-label mt-2">Due Date</label
                    >
                    <DatePicker
                      style="active select-border"
                      placeholder="Date"
                      on:change={(value) => {
                        $form.date2 = value.detail[1];
                      }}
                      value={$form.date2}
                    />
                    {#if $errors.date}
                      <label
                        class="formError"
                        for="reason">{$errors.date2}</label
                      >
                    {/if}
                  </div>
                </div>
              {/if}
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group position-relative">
              <label
                for=""
                class="form-label mt-2">Please tell us why are you making this change</label
              >
              <textarea
                class="form-control"
                bind:value={$form.reason}
                name="reason"
                placeholder="Enter Notes (Optional)"
                rows="6"
              ></textarea>
              {#if $errors.reason}
                <label
                  class="formError"
                  for="reason">{$errors.reason}</label
                >
              {/if}
            </div>
          </div>
          <div class="col-md-12">
            {#if requestFrom == 'taskList' && $form.dateType != 'dueDate' && $form.dateType != 'completeDate'}
              <label
                for=""
                class="form-label text-danger mt-2"
                >Note: Changing open date to a future date will lead to moving the open task to
                scheduled task tab.</label
              >
            {/if}
            {#if requestFrom == 'scheduleList' && $form.dateType != 'dueDate' && $form.dateType != 'completeDate'}
              <label
                for=""
                class="form-label text-danger mt-2"
                >Note: Changing open date to a past date will lead to moving the scheduled task to
                open task tab.</label
              >
            {/if}
          </div>

          <InfoAlert
            message={serverErrors}
            class="alert alert-danger w-100 mt-3"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              isLoading = true;
              handleSubmit();
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .button-tabber-modal button {
    border: 0px !important;
    border-radius: 6px !important;
  }
  .button-tabber-modal button.active {
    background-color: #fff !important;
  }
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
  .active,
  .active:hover {
    background-color: $blue-color;
    color: $white-color;
    border: 1px solid $blue-color;
  }
</style>
